import React from "react";
import { motion } from "framer-motion";
import { spring } from "../../utils/motion";
interface SegmentedOption<T extends string> {
  value: T;
  label: string;
  badge?: string;
}
interface SegmentedProps<T extends string> {
  id: string;
  options: SegmentedOption<T>[];
  value: T;
  onChange: (v: T) => void;
  label: string;
  full?: boolean;
}
export function Segmented<T extends string>({
  id,
  options,
  value,
  onChange,
  label,
  full
}: SegmentedProps<T>) {
  return <div role="tablist" aria-label={label} className={`inline-flex gap-1 rounded-xl border-3 border-line bg-surface p-1 ${full ? "w-full" : ""}`} data-id="element-1217" data-mp="3cwk5f5bj855d">
      {options.map(o => {
      const active = o.value === value;
      return <button key={o.value} type="button" role="tab" aria-selected={active} onClick={() => onChange(o.value)} className={`focus-ring relative flex-1 whitespace-nowrap rounded-lg px-3.5 py-2 text-sm font-semibold transition-colors duration-150 ${active ? "text-paper" : "text-ink-2 hover:text-ink"}`} data-id="element-1218" data-mp="3mltusdezr9ps">
            {active && <motion.span layoutId={`seg-${id}`} transition={spring.snappy} className="absolute inset-0 rounded-lg bg-ink" aria-hidden="true" data-id="element-1219" data-mp="emzmhqacgdh2" />}
            <span className="relative flex items-center justify-center gap-1.5" data-id="element-1220" data-mp="17alqv0rebm4z">
              {o.label}
              {o.badge && <span className="rounded-md bg-accent px-1.5 py-0.5 text-[10px] font-bold text-night" data-id="element-1221" data-mp="12ewwrcy5axg2">
                  {o.badge}
                </span>}
            </span>
          </button>;
    })}
    </div>;
}